import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const RecentItemsPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'recently_viewed' }));
    const canonical = `${baseUrl}/recent`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default RecentItemsPageHeaderMeta;
